// export this package's api
import Trigger from './src/';
export default Trigger;



// WEBPACK FOOTER //
// ./ext/trigger/index.js